var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCnbg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 246,
    viewBox: "0 0 206 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5008_1660)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205.256,
    height: 246,
    rx: 14.2668,
    fill: "#DBFFF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 168,
    width: 34,
    height: 103,
    rx: 17,
    fill: "url(#paint0_linear_5008_1660)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 202,
    width: 34,
    height: 103,
    rx: 17,
    transform: "rotate(90 199 202)",
    fill: "url(#paint1_linear_5008_1660)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 195,
    width: 34,
    height: 103,
    rx: 17,
    fill: "url(#paint2_linear_5008_1660)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 33,
    width: 34,
    height: 103,
    rx: 17,
    fill: "url(#paint3_linear_5008_1660)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.918,
    y: 7,
    width: 34,
    height: 103,
    rx: 17,
    transform: "rotate(41.998 29.918 7)",
    fill: "url(#paint4_linear_5008_1660)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5008_1660",
    x1: 7,
    y1: 168,
    x2: 7,
    y2: 271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5008_1660",
    x1: 216,
    y1: 202,
    x2: 216,
    y2: 305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5008_1660",
    x1: 55,
    y1: 195,
    x2: 55,
    y2: 298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5008_1660",
    x1: 182,
    y1: 33,
    x2: 182,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5008_1660",
    x1: 46.918,
    y1: 7,
    x2: 46.918,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5008_1660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205.256,
    height: 246,
    rx: 14.27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnbg2);
export default __webpack_public_path__ + "static/media/cnbg2.c77cd3f620ee5c9838430b93f03e1572.svg";
export { ForwardRef as ReactComponent };